import { useCallback } from 'react';
import { DataType, MAPPING_STATUS, filterIds } from '@constants';
import { CsvImportStatus, FetchCsvImportStatusSuccessResponse } from 'IntegrationModule/types';
import { fetchCsvImportStatus as _fetchCsvImportStatus } from 'thunk';
import useLocalDispatch from './useLocalDispatch';
import orderBy from 'lodash/orderBy';

type CsvImportStatusProps = {
  teamId: number;
  targetServiceId: number;
};

const stateId = String(filterIds.csvImportStatusTable);

export type FormattedCsvImportStatus = CsvImportStatus & {
  totalEntries: number;
};

const useCsvImportStatus = () => {
  const { dispatchLocal, selectLocalData } = useLocalDispatch();

  const csvImportStatusFetchData = selectLocalData<
    FormattedCsvImportStatus[],
    FormattedCsvImportStatus[]
  >({
    stateId,
    filterId: filterIds.csvImportStatusTable,
    formatData: ({ error, stateData = [], isRequesting, filter }) => {
      const formattedData = orderBy(
        Object.values(stateData).map((d) => {
          const formattedCountInBigQuery = d.countInBigQuery || 0;
          const data = {
            ...d,
            totalEntries: formattedCountInBigQuery,
          };
          return data;
        }),
        filter.orderBy,
        filter.orderDirection,
      );

      return formattedData;
    },
  });

  const fetchCsvImportStatus = useCallback(
    ({ teamId, targetServiceId }: CsvImportStatusProps) => {
      dispatchLocal(_fetchCsvImportStatus, {
        params: {
          mosaicTeamId: teamId,
          targetServiceId,
        },
        stateId,
      });
    },
    [dispatchLocal],
  );

  return {
    fetchCsvImportStatus,
    csvImportStatusFetchData,
  };
};

export default useCsvImportStatus;
